<template>
	<div class="section" :class="main_color">

		<div class="part part-profil-commune">
			
			<p class="label main_color_text">{{table_population.title.value}}</p>
			<div class="tle-row">
				<div class="tle-col half">
					<el-table :table="table_population" />
                    <span class = "legend">{{table_population.legend}}</span>
				</div>
				<div class="tle-col half">
					<el-table :table="table_menages" />
					<el-table :table="table_menages2" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import PageMixin from "@/components/study/editor/pages/page.mixin.js";

export default {
	name: "section-dynamique-territoriale",
	mixins: [ PageMixin ],
	data: function () {
		return {
			
		};
	},
	props: {
		main_color: { default: "" },
	},
	computed: {
		...mapGetters(["active_study", "editor", "app_parameters"]),
		table_population: function () {
			const table = { head: [], body: [], config: {
				cols_width: [ 40, 28, 28 ]
			} };
			try{
				let component = this.active_study.qlikData.component.find((component) => {
					return component.name == "population1" || component.id == "3.1.1";
				});

				table.title = component.title[0];

				//todelete : switch mode error/nominal (false => error case)
				//component.valid = true;
				//throw "il y a une erreur"

				// if an error is detectd in back => set componenet from default_component
				if (component.valid == false){
					//get error_message from component
					// table.error_message="[BACK] : "+component.errorMessage;
					table.error_message = "Donnée non disponible";

					//get defualt component
					component = this.app_parameters.default_components.find((component) => {
						return component.name == "population1" || component.id == "3.1.1";
					});
					table.error = true;
				}
               
				const header = component.content.commune.header_list.reduce((accu, curr) => {
					accu.push(curr.value);
					return accu;
				}, []);
				table.head.push(header);
                
				const body = component.content.commune.data_list.reduce((accu, curr) => {
					let suffix = curr.values[1].unit;
					if ((suffix == " pt" || suffix == "pt") && Math.trunc(Math.abs(curr.values[1].value)) >= 2) suffix += "s";
					accu.push([
						{value: curr.label},
						{value: curr.values[0].value, suffix: curr.values[0].unit, format: "number"},
						{prefix: curr.values[1].value > 0 ? "+" : "-" ,value: Math.abs(curr.values[1].value).toString(), suffix: suffix, format: "number"}
					]);
					return accu;
				}, []);

				table.body = body;
			}
			// if an error occured in front => //display empty table with error message
			catch(error){
				//get default component
				const component = this.app_parameters.default_components.find((component) => {
					return component.name == "population1" || component.id == "3.1.1";
				});

				table.error = true;
				// table.error_message= "[FRONT] : Une erreur est survenue veuillez contacter un administrateur!  : "+error;
				table.error_message = "Donnée non disponible";
				table.legend = component.legend[0].value ? component.legend[0].value : "* Revenu médian par ménage";
				const header = component.content.commune.header_list.reduce((accu, curr) => {
					accu.push(curr.value);
					return accu;
				}, []);
				table.head.push(header);
                
				const body = component.content.commune.data_list.reduce((accu, curr) => {
					accu.push([
						{value: curr.label},
						{value: curr.values[0].value, suffix: curr.values[0].unit, format: "number"},
						{prefix: curr.values[1].value > 0 ? "+" : "-" ,value: Math.abs(curr.values[1].value).toString(), suffix: curr.values[1].unit, format: "number"}
					]);
					return accu;
				}, []);

				table.body = body;

			}
			return table;
		},
		table_menages: function () {
			const table = { head: [], body: [], config: {
				cols_width: [ 40, 28, 28 ]
			} };
			try{
				let component = this.active_study.qlikData.component.find((component) => {
					return component.name == "population2" || component.id == "3.1.2";
				});
                

				//todelete : switch mode error/nominal (false => error case)
				// component.valid = true;
				// throw "il y a une erreur"

				// if an error is detectd in back => set componenet from default_component
				if (component.valid == false){
					//get error_message from component
					// table.error_message="[BACK] : "+component.errorMessage;
					table.error_message = "Donnée non disponible";
					//get defualt component
					component = this.app_parameters.default_components.find((component) => {
						return component.name == "population2" || component.id == "3.1.2";
					});
					table.error = true;
				}
               
				const header = component.content.commune.header_list.reduce((accu, curr) => {
					accu.push(curr.value);
					return accu;
				}, []);
				table.head.push(header);
                
				const body = component.content.commune.data_list.reduce((accu, curr) => {
                    
					let suffix = curr.values[1].unit;
					if ((suffix == " pt" || suffix == "pt") && Math.trunc(Math.abs(curr.values[1].value)) >= 2) suffix += "s";
					accu.push([
						{value: curr.label},
						{value: curr.values[0].value, suffix: curr.values[0].unit, format: "number"},
						{prefix: curr.values[1].value > 0 ? "+" : "-" ,value: Math.abs(curr.values[1].value).toString(), suffix: suffix, format: "number"}
					]);
					return accu;
				}, []);

				table.body = body;
			}
			// if an error occured in front => //display empty table with error message
			catch(error){
				//get defualt component
				const component = this.app_parameters.default_components.find((component) => {
					return component.name == "population2" || component.id == "3.1.2";
				});

				table.error = true;
				// table.error_message= "[FRONT] : Une erreur est survenue veuillez contacter un administrateur!  : "+error;
				table.error_message = "Donnée non disponible";

				const header = component.content.commune.header_list.reduce((accu, curr) => {
					accu.push(curr.value);
					return accu;
				}, []);
				table.head.push(header);
                
				const body = component.content.commune.data_list.reduce((accu, curr) => {
					accu.push([
						{value: curr.label},
						{value: curr.values[0].value, suffix: curr.values[0].unit, format: "number"},
						{prefix: curr.values[1].value > 0 ? "+" : "-" ,value: Math.abs(curr.values[1].value).toString(), suffix: curr.values[1].unit, format: "number"}
					]);
					return accu;
				}, []);

				table.body = body;

			}
			return table;
		},
		table_menages2: function () {
			const table = { head: [], body: [], config: {
				cols_width: [ 40, 28, 28 ]
			} };
			try{
				let component = this.active_study.qlikData.component.find((component) => {
					return component.name == "population3" || component.id == "3.1.3";
				});
                

				//todelete : switch mode error/nominal (false => error case)
				//component.valid = true;
				//throw "il y a une erreur"

				// if an error is detectd in back => set componenet from default_component
				if (component.valid == false){
					//get error_message from component
					// table.error_message="[BACK] : "+component.errorMessage;
					table.error_message = "Donnée non disponible";

					//get defualt component
					component = this.app_parameters.default_components.find((component) => {
						return component.name == "population3" || component.id == "3.1.3";
					});
					table.error = true;
				}else{
					table.error = false;
					table.error_message = "";
				}
               
				const header = component.content.commune.header_list.reduce((accu, curr) => {
					accu.push(curr.value);
					return accu;
				}, []);
				table.head.push(header);
                
				const body = component.content.commune.data_list.reduce((accu, curr) => {
                    
					let suffix = curr.values[1].unit;
					if ((suffix == " pt" || suffix == "pt") && Math.trunc(Math.abs(curr.values[1].value)) >= 2) suffix += "s";
					accu.push([
						{value: curr.label},
						{value: curr.values[0].value, suffix: curr.values[0].unit, format: "number"},
						{prefix: curr.values[1].value > 0 ? "+" : "-" ,value: Math.abs(curr.values[1].value).toString(), suffix: suffix, format: "number"}
					]);
					return accu;
				}, []);

				table.body = body;
			}
			// if an error occured in front => //display empty table with error message
			catch(error){
				//get defualt component
				const component = this.app_parameters.default_components.find((component) => {
					return component.name == "population3" || component.id == "3.1.3";
				});

				table.error = true;
				// table.error_message= "[FRONT] : Une erreur est survenue veuillez contacter un administrateur!  : "+error;
				table.error_message = "Donnée non disponible";

				const header = component.content.commune.header_list.reduce((accu, curr) => {
					accu.push(curr.value);
					return accu;
				}, []);
				table.head.push(header);
                
				const body = component.content.commune.data_list.reduce((accu, curr) => {
					accu.push([
						{value: curr.label},
						{value: curr.values[0].value, suffix: curr.values[0].unit, format: "number"},
						{prefix: curr.values[1].value > 0 ? "+" : "-" ,value: Math.abs(curr.values[1].value).toString(), suffix: curr.values[1].unit, format: "number"}
					]);
					return accu;
				}, []);

				table.body = body;

			}
			return table;
		},
	},
};
</script>

<style lang="stylus" scoped>
@import '../../../../../assets/css/app'
@import '../../../../../assets/css/page'

.legend
    font-style italic
    color #999
    font-size 8px
    line-height 10px
</style>